export default __webpack_public_path__ + "static/media/empty-icon.06149b03.svg";